import { arrayOf, oneOfType } from 'prop-types';

import { courseType } from './coursesType';
import { degreeType } from './degreeType';

export const educationalResourceType = oneOfType([courseType, degreeType]);
export const educationalResourcesType = arrayOf(educationalResourceType);
